import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo_salone_vincente.png";
import { YouTubePlayer } from "@/components/YouTubePlayer";

const VideoStep5 = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSignalLoading, setIsSignalLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  console.log("[VideoStep5] URL params:", {
    groupId: searchParams.get("groupId"),
    Id: searchParams.get("Id"),
    fullQueryString: searchParams.toString(),
  });

  const handleConsultationRequest = async () => {
    setIsLoading(true);

    const groupId = searchParams.get("groupId");
    const id = searchParams.get("Id");

    const webhookUrl = "https://n8n.srv1035791.hstgr.cloud/webhook/72fcb9f2-703f-49d8-b981-fd0722309d90";

    try {
      const response = await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event: "consultation_button_clicked",
          timestamp: new Date().toISOString(),
          page: "/7",
          source: "VideoStep5",
          groupId: groupId,
          Id: id,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
    } catch (error) {
      console.error("Error sending webhook:", error);
    } finally {
      navigate("/thank-you");
    }
  };

  const handleSignal = async () => {
    setIsSignalLoading(true);

    const groupId = searchParams.get("groupId");
    const id = searchParams.get("Id");

    const webhookUrl = "https://n8n.srv1035791.hstgr.cloud/webhook/37c32c26-e8da-4146-a657-de1efd304851";

    try {
      const response = await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event: "signal_sent",
          timestamp: new Date().toISOString(),
          page: "/7",
          source: "VideoStep5",
          groupId: groupId,
          Id: id,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      console.log("Signal sent successfully");
    } catch (error) {
      console.error("Error sending signal:", error);
    } finally {
      setIsSignalLoading(false);
    }
  };

  return (
    <div className="h-screen gradient-subtle flex flex-col p-4">
      <div className="flex-1 flex items-center justify-center">
        <div className="max-w-5xl w-full flex flex-col">
          <div className="flex items-center gap-4 mb-2 md:mb-3 animate-fade-in">
            <img
              src={logo}
              alt="Salone Vincente"
              className="w-12 h-12 md:w-16 md:h-16 object-contain animate-float flex-shrink-0"
            />
            <h1 className="flex-1 text-center text-lg md:text-2xl font-bold bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent">
              2 ORE DI CONSULENZA GRATUITA
            </h1>
          </div>

          <div className="relative card p-2 md:p-3 shadow-elegant animate-slide-up">
            <YouTubePlayer videoId="LX52gNu1buQ" />
          </div>

          <div className="flex flex-col gap-3 mt-3 md:mt-4 animate-fade-in max-w-xl mx-auto w-full">
            <Button
              onClick={handleConsultationRequest}
              size="lg"
              className="w-full whitespace-normal rounded-xl text-sm sm:text-base md:text-lg font-semibold px-6 py-5 sm:py-6 h-auto bg-gradient-to-r from-primary to-accent hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
              disabled={isLoading}
            >
              {isLoading ? "Invio in corso..." : "✨ Voglio essere contattata per la consulenza gratuita"}
            </Button>

            <Button
              onClick={handleSignal}
              size="lg"
              className="w-full rounded-xl text-sm sm:text-base md:text-lg font-semibold px-6 py-5 sm:py-6 h-auto bg-gradient-to-r from-destructive to-[hsl(15,80%,55%)] hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] text-destructive-foreground"
              disabled={isSignalLoading}
            >
              {isSignalLoading ? "Invio in corso..." : "📩 Inviami il bonus in regalo"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoStep5;
